import React from 'react'
import { Deferred } from 'simply-deferred'

import Popover from '../../gd-components/gd-popover/popover-v2'
import PopoverPosition from '../../gd-components/gd-popover/popover-position'
import {PopoverAttachmentType, PopoverHeightRestriction} from '../../gd-components/gd-popover/@const'

import HintPopover from '../hint-popover/hint-popover'
import {SelectTaskTypeOption, SelectTaskTypeProps, SelectTaskTypeState} from "./@types"
import {getAllTaskTypes, getInitialState, getStateUpdateFromProps, getTaskTypeOptions} from "./select-task-type-state"
import {SelectTaskTypeValueMulti, SelectTaskTypeValueSingle} from "./select-task-type-value"
import SelectTaskTypeOptions from "./select-task-type-options"

// This is deprecated... use Fields
export default class SelectTaskType extends React.Component<SelectTaskTypeProps, SelectTaskTypeState> {

    static defaultProps = {
        placeholder: 'Task type',
        multiselect: false,
        canHaveNoValue: false,
        disabled: false,

        attachment: 'top center',
        targetAttachment: 'bottom center',
    }

    allTaskTypes : string[]

    constructor(props:SelectTaskTypeProps) {
        super(props)

        this.allTaskTypes = getAllTaskTypes(props)
        this.state = getInitialState(props)

        this.togglePopover = this.togglePopover.bind(this)
    }

    UNSAFE_componentWillMount() {
        if (this.props.form) {
            this.props.form.registerFormComponent(this.props.name,this)
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps:SelectTaskTypeProps) {
        const updateState = getStateUpdateFromProps(nextProps, this.props, this.state)

        if (Object.keys(updateState).length > 0) {
            this.setState(updateState as SelectTaskTypeState)
        }
    }


    togglePopover() {
        if (!this.props.disabled) {
            const showPopover = !this.state.showPopover
            this.setState({
                showPopover: showPopover
            },()=>{
                if (this.props.onTogglePopover) {
                    this.props.onTogglePopover(showPopover)
                }
            })
        }
    }

    // close popover + set value
    hidePopover(selectedOption:SelectTaskTypeOption=null) {

        let showPopover = false
        let value = this.state.value
        let values = this.state.values
        const stateChanged = new Deferred()

        if (selectedOption) {
            switch (selectedOption.type) {
                case 'task-type':
                    const ttId = selectedOption.taskType.id
                    if (this.props.multiselect) {
                        const idx = values.indexOf(ttId)
                        if (idx == -1) {
                            values.push(ttId)
                        } else {
                            values.splice(idx, 1)
                        }
                        showPopover = true
                    } else {
                        value = ttId
                    }
                    break
                case 'no-value':
                    value = this.props.noValueValue
                    values = []
                    break
            }
        }

        this.setState({
            showPopover: showPopover,
            value: value,
            values: values,
        },()=>{
            stateChanged.resolve()
            if (this.props.onTogglePopover) {
                this.props.onTogglePopover(false)
            }
        })

        return stateChanged
    }

    onOptionSelected = (option:SelectTaskTypeOption) => {
        if (option.disabled) {
            return
        }

        const stateChanged = this.hidePopover(option)

        const { name, multiselect, form, noValueValue, onUserSelect } = this.props

        if (!form && !onUserSelect) {
            return
        }

        const oldValue = this.state.value

        switch (option.type) {
            case 'task-type':
                if (multiselect) {
                    stateChanged.done(() => {
                        form && form.onFormComponentValueChange(name, this.state.values)
                        onUserSelect && onUserSelect( this.state.values)
                    })
                } else {
                    const ttId = option.taskType.id
                    if (ttId != oldValue) {
                        form && form.onFormComponentValueChange(name, ttId)
                        onUserSelect && onUserSelect(ttId)
                    }
                }
                break
            case 'no-value':
                if (multiselect) {
                    form && form.onFormComponentValueChange(name, noValueValue)
                } else {
                    if (noValueValue != oldValue) {
                        form && form.onFormComponentValueChange(name, noValueValue)
                        onUserSelect && onUserSelect(noValueValue)
                    }
                }
                break
        }
    }

    renderPopover() {
        if (!this.state.showPopover) {
            return false
        }

        const { attachment, targetAttachment, offset, fitSelectorWidth } = this.props
        const popoverConstraints = [
            {
                to: "window",
                attachment: "together",
                pin: true
            }
        ]

        const popoverClasses = Classes('gd-select-task-type-popover', this.props.popoverClass, 'render-'+this.props.renderValue)

        return (
            <Popover popoverClass={popoverClasses}
                     className="gd-select-task-type-container"
                     position={new PopoverPosition({attachment: attachment, targetAttachment: targetAttachment, offset: offset, attachmentType: PopoverAttachmentType.FULL})}
                     targetClass="pop-target"
                     constraints={popoverConstraints}
                     onClickOutside={()=>{this.hidePopover()}}
                     fitTargetWidth={fitSelectorWidth}
                     heightRestriction={PopoverHeightRestriction.HALF_WINDOW_HEIGHT}>
                <div className="gd-popup-menu-items s-13">
                    <SelectTaskTypeOptions options      = {getTaskTypeOptions(this.allTaskTypes, this.state.allowedTaskTypes, this.props.canHaveNoValue)}
                                           values       = {this.state.values}
                                           multiselect  = {this.props.multiselect}
                                           noValueLabel = {this.props.noValueLabel}
                                           onSelect     = {this.onOptionSelected} />
                </div>
            </Popover>
        )

    }

    renderValue() {
        if (this.props.multiselect) {
            return (
                <SelectTaskTypeValueMulti values      = {this.state.values}
                                          placeholder = {this.props.placeholder}
                                          renderValue = {this.props.renderValue}
                                          onClick     = {this.togglePopover} />
            )
        }

        return (
            <SelectTaskTypeValueSingle value           = {this.state.value}
                                       placeholder     = {this.props.placeholder}
                                       renderValue     = {this.props.renderValue}
                                       renderValueFunc = {this.props.renderValueFunc}
                                       onClick         = {this.togglePopover} />
        )
    }

    render() {
        const classes = Classes('gd-select-task-type', this.props.className,  'render-'+this.props.renderValue, {
            'underlined-always'     : this.props.underlined === 'always',
            'underlined-on-hover'   : this.props.underlined === 'on-hover',
            'is-disabled'           : this.props.disabled,
            'open'                  : this.state.showPopover
        })

        return (
            <div className={classes}>
                {this.renderValue()}
                {this.renderPopover()}

                {this.props.hint && !this.state.showPopover && <HintPopover parent={this} hint={this.props.hint}/>}
            </div>
        )
    }

}
